// domain/jasa — logika murni Jasa Servis (Edit Massal + harga Rp/% dari sparepart).
export type HargaType = 'rp' | 'persen';
export interface JasaRow { id: number; nama: string; modal: number; toko: number; user: number; garansi: string; hargaTypeToko?: HargaType; hargaTypeUser?: HargaType }

/**
 * Harga jual jasa = harga sparepart + biaya (model terpadu, per contoh Apo).
 * - hargaType 'persen'→ biaya = sparepart × nilai% → total = sparepart × (1 + nilai/100). Cth: 100rb, 60% → 160rb.
 * - hargaType 'rp'    → biaya = nilai Rupiah tetap → total = sparepart + nilai. Cth: part 20rb + biaya 150rb → 170rb.
 * partPrice 0 → 'rp' hasil = nilai (jasa tanpa part / labor saja); 'persen' hasil = 0.
 * Dipakai kalkulator CS & auto-isi biaya di Hasil Pengerjaan.
 */
export function jasaSellPrice(hargaType: HargaType, nilai: number, partPrice: number): number {
  const v = Number.isFinite(nilai) ? nilai : 0;
  const base = Math.max(0, Number.isFinite(partPrice) ? partPrice : 0);
  if (hargaType === 'persen') return Math.max(0, Math.round(base * (1 + v / 100)));
  return Math.max(0, Math.round(base + v)); // Rp: sparepart + biaya
}

/**
 * Kembalikan HANYA baris yang berubah (bandingkan edited vs original by id).
 * v0.18 saveBulk menulis SEMUA baris; hasil identik tapi kita lewati yang tak berubah
 * (services.id = generated always → tak bisa upsert-with-id; N update() untuk yang berubah saja).
 */
export function changedRows(original: JasaRow[], edited: JasaRow[]): JasaRow[] {
  const byId = new Map(original.map((o) => [o.id, o]));
  return edited.filter((e) => {
    const o = byId.get(e.id);
    if (!o) return true; // id tak dikenal → anggap berubah (defensif)
    return o.nama !== e.nama || o.modal !== e.modal || o.toko !== e.toko || o.user !== e.user || o.garansi !== e.garansi
      || (o.hargaTypeToko ?? 'rp') !== (e.hargaTypeToko ?? 'rp') || (o.hargaTypeUser ?? 'rp') !== (e.hargaTypeUser ?? 'rp');
  });
}
